<div class="position-relative">
    <!-- Loading overlay with WCAG 2.1 AA compliance -->
    <div *ngIf="isLoading"
         class="loading-overlay"
         role="status"
         aria-live="polite"
         aria-busy="true">
        <div class="loader-wrapper">
            <div class="loader" role="status">
                <span class="visually-hidden">Loading page {{ currentPage }}...</span>
            </div>
            <p class="mt-3 text-center">Loading page {{ currentPage }}...</p>
        </div>
    </div>

    <!-- Content slot with dimming effect -->
    <div [class.loading-dimmed]="isLoading">
        <ng-content></ng-content>
    </div>
</div>
